import axios from 'axios';
import { endpoints } from 'utils/global-constants';

/**
 * Register account information
 * @param {object} requestPayload
 * @returns
 */
export const saveRegistrationInformation = async (requestPayload) => {
  try {
    const response = await axios.post(endpoints.saveRegistrationInformation, requestPayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Update account information
 * @param {object} requestPayload
 * @returns
 */
export const updateAccountInformation = async (requestPayload) => {
  try {
    const response = await axios.post(endpoints.updateAccountInformation, requestPayload);

    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Get states for a specific selected countryId
 * @param {number} countryId
 * @returns
 */
export const getStates = async (countryId) => {
  try {
    const getStatesEndpoint = `${endpoints.getStates}/${countryId}`;
    const response = await axios.get(getStatesEndpoint);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Add the selected membership to cart
 * @param {object} requestPayload
 * @returns
 */
export const addMembershipToCart = async (requestPayload) => {
  try {
    const response = await axios.post(endpoints.addMembershipToCart, requestPayload);

    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Used in updating user account password
 * @param {object} requestPayload
 * @returns
 */
export const changePassword = async (requestPayload) => {
  try {
    const response = await axios.post(endpoints.changePassword, requestPayload);

    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Forgot user password service
 * @param {object} requestPayload
 * @returns
 */
export const forgotUserPassword = async (requestPayload) => {
  try {
    const response = await axios.post(endpoints.forgotUserPassword, requestPayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Reset User password service
 * @param {object} requestPayload
 * @returns
 */
export const resetUserPassword = async (requestPayload) => {
  try {
    const response = await axios.post(endpoints.resetUserPassword, requestPayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Set users communication preferences
 * @param {object} setPreferences
 * @returns
 */
export const setPreferences = async (userData) => {
  try {
    const response = await axios.post(endpoints.userPreference, userData);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Set users delivery addressess
 * @param {object} setAddressDetails
 * @returns
 */
export const setAddressDetails = async (data) => {
  try {
    const response = await axios.post(endpoints.updateAddressInformation, data);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Set users communication preferences
 * @param {object} deleteAddressDetails
 * @returns
 */
export const deleteAddress = async (data) => {
  try {
    const response = await axios.post(endpoints.deleteAddressInformation, data);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Make address primary for delivery
 * @param {object} addressDetails
 * @returns
 */
export const makePrimaryAddress = async (data) => {
  try {
    const response = await axios.post(endpoints.makePrimaryAddress, data);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Log in existing user
 * @param {object} loginFormPayload
 * @returns
 */
export const loginUser = async (loginFormPayload) => {
  const payload = {
    GuestEmail: null,
    GuestPassword: null,
    RegisterErrorMessage: null,
    IsLoginSectionInVisible: false,
    HideForgotPassword: false,
    HideRegister: false,
    RegisterButtonText: 'Continue registration',
    FromPurchasePath: false,
    HumanCheck: null,
    Email: loginFormPayload.inputEmailSignin,
    Password: loginFormPayload.inputPasswordSignin,
    ConfirmPassword: null,
    Title: null,
    FirstName: null,
    LastName: null,
    DOBDay: null,
    DOBMonth: null,
    DOBYear: null,
    PhoneNumber: null,
    MobileNumber: null,
    SubscribeNewsletters: false,
    ChangeEmailAddress: false,
    Redirect: false,
    RedirectUrl: null,
    ErrorMessage: null,
    ComplexErrorMessage: null,
    SuccessMessage: null,
  };

  try {
    const response = await axios.post(endpoints.loginUser, payload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Register new user
 * @param {object} registerFormPayload
 * @returns
 */
export const saveGuestRegistrationInformation = async (registerFormPayload) => {
  const registrationApiPayload = {
    GuestEmail: registerFormPayload.inputEmailContinue,
    GuestPassword: null,
    RegisterErrorMessage: null,
    IsLoginSectionInVisible: false,
    HideForgotPassword: false,
    HideRegister: false,
    RegisterButtonText: 'Continue registration',
    FromPurchasePath: false,
    ConfirmPassword: null,
    Title: null,
    FirstName: registerFormPayload.inputFirstNameContinue,
    LastName: registerFormPayload.inputLastNameContinue,
    DOBDay: null,
    DOBMonth: null,
    DOBYear: null,
    PhoneNumber: null,
    MobileNumber: null,
    SubscribeNewsletters: false,
    ChangeEmailAddress: false,
    Redirect: false,
    RedirectUrl: null,
    ErrorMessage: null,
    ComplexErrorMessage: null,
    SuccessMessage: null,
  };

  try {
    const response = await axios.post(
      endpoints.saveGuestRegistrationInformation,
      registrationApiPayload
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
